/**
 * T094: useCreateCategory Hook
 * Mutation hook for creating categories
 */

import { useMutation, useQueryClient } from '@tanstack/react-query'
import { createCategory, type CreateCategoryInput } from '@/services/categories'
import { queryKeys } from '@/lib/query-keys'

export function useCreateCategory() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (input: CreateCategoryInput) => createCategory(input),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.categories.all })
    },
  })
}
